export default function removeTokenFromLocalStorage() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('access_token_tokenExpirationDate');
}
